import { render, staticRenderFns } from "./classify-process.vue?vue&type=template&id=158d8d89&scoped=true"
import script from "./classify-process.vue?vue&type=script&lang=js"
export * from "./classify-process.vue?vue&type=script&lang=js"
import style0 from "./classify-process.vue?vue&type=style&index=0&id=158d8d89&prod&scoped=true&lang=scss"
import style1 from "./classify-process.vue?vue&type=style&index=1&id=158d8d89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d8d89",
  null
  
)

export default component.exports